enum ActionTypes {
  FETCH_TENANT_FEATURE_FLAGS_START = "FETCH_TENANT_FEATURE_FLAGS_START",
  FETCH_TENANT_METADATA_SUCCESS = "FETCH_TENANT_METADATA_SUCCESS",
  FETCH_TENANT_METADATA_ERROR = "FETCH_TENANT_METADATA_ERROR",
}

export default ActionTypes;
